// @flow
export type PlainAntenna = {
  latitude: number;
  longitude: number;
  strengthRadiusInMeters: number;
}

export default class Antenna {
  latitude: number;
  longitude: number;
  strengthRadiusInMeters: number;

  constructor(
    laltitude: number,
    longitude: number,
    strengthRadiusInMeters: number,
  ) {
    this.latitude = laltitude;
    this.longitude = longitude;
    this.strengthRadiusInMeters = strengthRadiusInMeters;
  }

  static parse(data: PlainAntenna) {
    return new Antenna(data.latitude, data.longitude, data.strengthRadiusInMeters);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/domain/Antenna.js